import { useEffect } from "react";
import "./PrivacyAndPolicy.css";
import Footer from "../Footer";
import Head from "../Head";
const PrivacyAndPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="top-head-section-new"></div>
      <div className="faq-section  term-condition-heading">
        <div className="container">
          <div className="aboutUs-header">
            <Head />
          </div>
          <h2 class="aboutUs-heading main-container-section">Privacy Policy</h2>
          <div className="about-us">
            <h5>&nbsp; &nbsp;Effective Date: 1/1/25</h5>
            <br />
            <ol className="order-list">
              <li>
                <h4> Introduction</h4>
                <p>
                  Welcome to LF Coin ($LAL). We respect your privacy and are
                  committed to protecting your personal data. This Privacy
                  Policy outlines how we collect, use, and safeguard information
                  when you interact with our website, social media, and
                  blockchain-related services.
                </p>
              </li>
              <li>
                <h4>Information We Collect</h4>
                <div className="standfor">
                  <ul>
                    <li>
                      <b>Personal Information:</b>&nbsp; When you sign up for
                      newsletters, participate in giveaways, or engage with our
                      community, we may collect your name, email, and wallet
                      address.
                    </li>
                    <li>
                      <b>Automated Information:</b>&nbsp; We collect
                      non-personal data such as IP addresses, browser type, and
                      device information for analytics and security purposes.
                    </li>
                    <li>
                      <b>Blockchain Transactions:</b>&nbsp; As a decentralized
                      project, transactions involving $LAL are recorded on the
                      Solana blockchain. These records are publicly accessible
                      and cannot be modified.
                    </li>
                  </ul>
                </div>
              </li>
              <br />
              <li>
                <h4 className="mb-2 mt-0">How We Use Your Information</h4>
                <ul>
                  <li>
                    To provide and improve our website, community, and services.
                  </li>
                  <li>
                    To communicate with users regarding updates, promotions, and
                    events.
                  </li>
                  <li>
                    To ensure compliance with legal and security requirements.
                  </li>
                </ul>
              </li>
              <br />
              <li>
                <h4>Third-Party Sharing</h4>
                <p className="mb-0">
                  We do not sell or share personal data with third parties,
                  except when required for legal compliance, fraud prevention,
                  or third-party service integration (e.g., payment processing
                  via MoonPay).
                </p>
              </li>
              <br />
              <li>
                <h4>Security Measures</h4>
                <p className="mb-0">
                  We implement industry-standard security practices to protect
                  personal and transaction-related data. However, users should
                  practice security precautions when using crypto-related
                  services.
                </p>
              </li>
              <br />
              <li>
                <h4>User Rights & Contact Information</h4>
                <p>
                  Users may request access, correction, or deletion of personal
                  information by contacting us at{" "}
                  <u>
                    <a href="mailto:support@lfcoin.io" className="support-link">
                      support@lfcoin.io
                    </a>
                  </u>
                </p>
              </li>
            </ol>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 disclouser-sec">
              <div className="lend-cont-inner-in">
                <p>
                  <strong>Disclosure: </strong>
                  LF Coin ($LAL) is a community-driven meme coin created to
                  celebrate sports fandom and foster community engagement. LF
                  Coin is not affiliated with the Los Angeles Lakers, the
                  National Basketball Association (NBA), or any associated
                  organizations. The project operates independently and is
                  solely focused on building a decentralized community of sports
                  enthusiasts. As a meme coin, LF Coin carries no intrinsic
                  value and should not be considered an investment or security.
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div className="about-footer">
        <Footer />
        </div>
    </>
  );
};

export default PrivacyAndPolicy;
